/**
 * Qualifiable Cost Type Enum
 *
 * Defines types of non-quantified (qualifiable) costs representing risks or concerns.
 */
export const QualifiableCostTypeLabel = {
    retention_risk: 'Employee Retention Risk',
    security_concern: 'Security Concern',
    compliance_concern: 'Compliance Concern',
    customer_churn_risk: 'Customer Churn Risk',
    technical_debt: 'Technical Debt',
    operational_risk: 'Operational Risk',
    other: 'Other',
};
export const QualifiableCostTypeDescription = {
    retention_risk: 'Risk of losing key employees if not addressed',
    security_concern: 'Security vulnerabilities or risks',
    compliance_concern: 'Regulatory or compliance issues',
    customer_churn_risk: 'Risk of losing customers if not addressed',
    technical_debt: 'Accumulated technical debt impacting velocity',
    operational_risk: 'Risks to day-to-day operations',
    other: 'Other qualifiable cost concerns',
};
export const QUALIFIABLE_COST_TYPES = [
    'retention_risk',
    'security_concern',
    'compliance_concern',
    'customer_churn_risk',
    'technical_debt',
    'operational_risk',
    'other',
];
//# sourceMappingURL=qualifiable-cost-type.enum.js.map